import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { GroupUserAttributes } from 'components/groups';

import type { Achievement } from 'shared-types';

interface Props {
  updateSupervisors: () => Promise<void>;
}

const AchievementSupervisorsConditions = ({ updateSupervisors }: Props) => {
  const { dispatch } = useDispatch();
  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  const supervisorConditions = achievement.supervisorConditions || [];

  const updateAchievementAndSupervisors = async (
    data: Pick<Achievement, 'supervisorConditions'>
  ) => {
    const response = await api.put(
      `/admin/achievements/${achievement.id}`,
      data
    );

    if (response?.data?.success) {
      dispatch(
        actions.updatePageState({ achievement: { ...achievement, ...data } })
      );
      await updateSupervisors();
    } else {
      throw new Error('error updating achievement');
    }
  };

  const handleAddOrEditCondition = async (
    newConditions: Achievement['supervisorConditions'][0],
    conditionsIndex?: number
  ) => {
    await updateAchievementAndSupervisors({
      supervisorConditions:
        conditionsIndex !== undefined
          ? [
              ...supervisorConditions.slice(0, conditionsIndex),
              newConditions,
              ...supervisorConditions.slice(conditionsIndex + 1)
            ]
          : [...supervisorConditions, newConditions]
    });
  };

  const handleRemoveCondition = async (attributeIndex: number) => {
    try {
      await updateAchievementAndSupervisors({
        supervisorConditions: supervisorConditions.filter(
          (attr, i) => i !== attributeIndex
        )
      });
      return true;
    } catch (err) {
      return false;
    }
  };

  return (
    <GroupUserAttributes
      onAddUserAttribute={handleAddOrEditCondition}
      onEditUserAttribute={handleAddOrEditCondition}
      onRemoveUserAttribute={handleRemoveCondition}
      title={messages.userAttributesConditions}
      userAttributes={supervisorConditions}
    />
  );
};

export default AchievementSupervisorsConditions;
